/**
 * Safely parses and resolves single or multi-image Cloudinary/local URL paths.
 * Supports stringified JSON arrays, full HTTP/HTTPS URLs, and local relative paths.
 */
export const getImageUrl = (imageSrc, defaultFallback = "") => {
  if (!imageSrc) return defaultFallback;
  let src = imageSrc;

  // Handle stringified JSON array of image URLs
  if (typeof src === "string" && src.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(src);
      if (Array.isArray(parsed) && parsed.length > 0) {
        src = parsed[0];
      }
    } catch (e) {
      console.error("Error parsing image JSON array:", e);
    }
  }

  if (typeof src === "string" && (src.startsWith("http://") || src.startsWith("https://"))) {
    return src;
  }

  if (typeof src === "string" && src.trim()) {
    const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
    return `${BASE_URL}/${src.replace(/^\//, "")}`;
  }

  return defaultFallback;
};

/**
 * Returns an array of image URLs from a single URL, stringified JSON array, or null.
 */
export const getAllImageUrls = (imageSrc) => {
  if (!imageSrc) return [];
  if (Array.isArray(imageSrc)) {
    return imageSrc.map((url) => getImageUrl(url)).filter(Boolean);
  }
  if (typeof imageSrc === "string" && imageSrc.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(imageSrc);
      if (Array.isArray(parsed)) {
        return parsed.map((url) => getImageUrl(url)).filter(Boolean);
      }
    } catch (e) {
      console.error("Error parsing image JSON array:", e);
    }
  }
  const resolved = getImageUrl(imageSrc);
  return resolved ? [resolved] : [];
};
